import { ComponentAdditionPageState } from ".";
import {
  CpntAlctnType,
  CpntOwnType,
  InDefCommonFlagType,
} from "../../util/general-code/enums/general-codes";

const displayColumn = [
  { label: "Name", value: "ichrName" },
  { label: "Position", value: "pstnName" },
  { label: "Company", value: "cmpnyName" },
  { label: "Tel", value: "telNum" },
  { label: "Mail address", value: "mlAdrs" },
];

export const ComponentAdditionPageInitialState: ComponentAdditionPageState = {
  searchResult: {
    godFlg: "",
    rootCpntId: "",
    rootCpntName: "",
    dipByRgn: "",
    ownTypeCd: CpntOwnType.APP,
    systemName: "",
    systemId: "",
    subSystemId: "",
    notSystemUsg: "",
    alctnTypeCd: CpntAlctnType.ALL,
    clodSrvcTypeCd: "",
    rgnTypeCd: "",
    acntName: "",
    rootCpntIchr: [
      {
        isChanged: InDefCommonFlagType.YES,
        ichrId: "",
        ichrName: "",
        pstnName: "",
        cmpnyName: "",
        telNum: "",
        mlAdrs: "",
        updateDateTimeMRootCpntIchr: "",
      },
    ],
    cpntId: "",
    cpntName: "",
    cpntDesc: "",
    gpgEncryptnFlg: InDefCommonFlagType.NO,
    useAssmdRoleFlg: InDefCommonFlagType.NO,
    ediUsgFlg: InDefCommonFlagType.NO,
    useEdhCnvtrFlg: InDefCommonFlagType.NO,
    hubFlg: InDefCommonFlagType.NO,
    edhPrtclList: [],
    ifStrtMthdList: [],
    edhNtfctnTypeList: [],
  },
  spreadsheetSelectedRowIndex: undefined,
  formValidation: {
    rootCpntId: true,
    rootCpntName: true,
    dipByRgn: true,
    ownTypeCd: true,
    systemName: true,
    systemId: true,
    subSystemId: true,
    notSystemUsg: true,
    alctnTypeCd: true,
    clodSrvcTypeCd: true,
    rgnTypeCd: true,
    acntName: true,
    cpntId: true,
    cpntName: true,
    cpntDesc: true,
    gpgEncryptnFlg: true,
    useAssmdRoleFlg: true,
    useEdhCnvtrFlg: true,
    hubFlg: true,
    edhPrtclList: true,
    ifStrtMthdList: true,
    inboundNotificatorList: true,
    outboundNotificatorList: true,
    ediUsgFlg: true,
  },
  edhProtocolCombination: [],
  dataList: {
    cpntOwnType: [],
    cpntAlctnType: [],
    clodSrvc: [],
    clodSrvcRgn: [],
    edhProtcolList: [],
    startMethod: [],
    inboundNotificator: [],
    outboundNotificator: [],
    dipByRgnList: [],
    rootComponent: [],
    dynamicEdhProtocolList: [],
    dynamicStartMethod: [],
  },
  isEdited: false,
  displayColumn: displayColumn,
  formEditData: {
    edhPrtclList: [],
    ifStrtMthdList: [],
    inboundNotificatorList: [],
    outboundNotificatorList: [],
  },
  fieldPath: {
    rootCpntId: "rootCpntId",
    rootCpntName: "rootCpntName",
    dipByRgn: "dipByRgn",
    ownTypeCd: "ownTypeCd",
    systemName: "systemName",
    systemId: "systemId",
    subSystemId: "subSystemId",
    notSystemUsg: "notSystemUsg",
    alctnTypeCd: "alctnTypeCd",
    clodSrvcTypeCd: "clodSrvcTypeCd",
    rgnTypeCd: "rgnTypeCd",
    acntName: "acntName",
    cpntId: "cpntId",
    cpntName: "cpntName",
    cpntNameWtngChng: "cpntNameWtngChng",
    cpntDesc: "cpntDesc",
    gpgEncryptnFlg: "gpgEncryptnFlg",
    useAssmdRoleFlg: "useAssmdRoleFlg",
    useEdhCnvtrFlg: "useEdhCnvtrFlg",
    ediUsgFlg: "ediUsgFlg",
    edhPrtclList: "edhPrtclList",
    ifStrtMthdList: "ifStrtMthdList",
    edhNtfctnTypeList: "edhNtfctnTypeList",
    hubFlg: "hubFlg",
    updateDateTimeMCpnt: "updateDateTimeMCpnt",
  },
};
